/**
 * Shared contract for mapping legacy business function names to domain TCB functions.
 * Clients keep their existing function names; only the transport target changes.
 */
import domainConfig from './function-domains.json'

export const DOMAIN_NAMES = [
  'auth',
  'iam',
  'master',
  'lead',
  'project',
  'finance',
  'inventory',
  'report',
  'platform',
  'owner',
  'cockpit',
  'system',
] as const

export type FunctionDomain = (typeof DOMAIN_NAMES)[number]

export const FUNCTION_DOMAINS = domainConfig as Record<FunctionDomain, readonly string[]>

const FUNCTION_DOMAIN_BY_NAME = new Map<string, FunctionDomain>()
for (const domain of DOMAIN_NAMES) {
  for (const name of FUNCTION_DOMAINS[domain]) {
    FUNCTION_DOMAIN_BY_NAME.set(name, domain)
  }
}

/** Resolve a legacy function name to its aggregate TCB function name. */
export function resolveFunctionDomain(name: string): FunctionDomain {
  const domain = FUNCTION_DOMAIN_BY_NAME.get(name)
  if (!domain) {
    throw new Error(`[tcb] 未配置云函数域映射: ${name}`)
  }
  return domain
}

/** Return whether a legacy function name is registered in the shared routing contract. */
export function isKnownFunctionName(name: string): boolean {
  return FUNCTION_DOMAIN_BY_NAME.has(name)
}

/** Return the legacy names registered for one aggregate domain. */
export function getDomainFunctionNames(domain: FunctionDomain): readonly string[] {
  return FUNCTION_DOMAINS[domain]
}
